import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { ErrorPrefix } from "Constants/constants";
import { zipCodeRegex } from "Features/CheckPrice/Products/RiskProducts/riskProductsUtils";
import { isGrossAreaInvalid } from "../cabinConditions";
import { CONSTRUCTION_YEAR_LIMIT } from "../cabinConstants";
import { CabinProductIntroFormValues } from "./cabinProductIntroInterfaces";

const grossAreaLargerThanLiving = (
  grossArea?: string,
  livingArea?: string,
): boolean => {
  return grossArea && livingArea
    ? parseInt(grossArea) >= parseInt(livingArea)
    : false;
};

export const validationSchema =
  (): Yup.ObjectSchema<CabinProductIntroFormValues> => {
    const { getText } = TextManager;

    return Yup.object({
      postNumber: Yup.string()
        .required(getText("cabinform.validation.postnumber_required"))
        .matches(
          zipCodeRegex,
          getText("cabinform.validation.postnumber_invalid"),
        )
        .test(
          "postnumber is valid",
          getText("cabinform.validation.postnumber_invalid"),
          function () {
            return this.parent.validPostNumber;
          },
        ),
      city: Yup.string(),
      validPostNumber: Yup.boolean(),
      constructionYear: Yup.string()
        .required(getText("cabinform.validation.constructionyear_required"))
        .test(
          "constructionYear",
          ErrorPrefix.BREAKING +
            getText("cabinform.validation.constructionyear_invalid", {
              variables: {
                cabin_constructionYearLimit: CONSTRUCTION_YEAR_LIMIT,
              },
            }),
          (value) => {
            const date = parseInt(value || "0");
            return (
              date <= new Date().getFullYear() &&
              date >= CONSTRUCTION_YEAR_LIMIT
            );
          },
        ),
      grossArea: Yup.string()
        .required(getText("cabinform.validation.grossarea_required"))
        .test(
          "grossArea",
          ErrorPrefix.BREAKING +
            getText("cabinform.validation.grossarea_toolarge"),
          (value) => {
            return !isGrossAreaInvalid(value);
          },
        ),
      livingArea: Yup.string()
        .required(getText("cabinform.validation.livingarea_required"))
        .test(
          "grossAreaLargerThanLivingArea",
          getText("cabinform.validation.livingarea_toolarge"),
          function (value) {
            return (
              value &&
              this.parent.grossArea &&
              grossAreaLargerThanLiving(this.parent.grossArea, value)
            );
          },
        ),
      otherBuildings: Yup.array()
        .of(
          Yup.object().shape({
            type: Yup.string().required(),
            areal: Yup.string().required(),
            constructionYear: Yup.string().required(),
            id: Yup.string().required(),
            isolated: Yup.boolean(),
          }),
        )
        .required(),
    }).defined();
  };
